<template>
  <div>
    <div class="row">
      <div class="col-12 px-3">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th>{{ $t("nombre") }}</th>
              <th>{{ $t("apellidos") }}</th>
              <th>{{ $t("acciones") }}</th>
            </tr>
          </thead>
          <tbody>
              <tr v-for="(c, n) in criadores" :key="n">
              <td class="text-left pl-1">{{ c.name }}</td>
              <td class="text-left pl-1">{{ c.lastname }}</td>            
              <!-- botones de accion -->
              <td class="px-0">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-primary btn-gr mx-1 mini-btn my-auto"
                  @click="editar(c)"
                >
                  <i aria-hidden="true" class="fa fa-edit"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger btn-gr mini-btn my-auto mx-0"
                  @click="eliminar(n)"
                >
                  <i aria-hidden="true" class="fa fa-trash-o"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dog-criador-list",
  props: ["lista"],
  methods: {
    /* enviar al parent editar coprop */
    editar(c) {
      console.log(c);
      this.$emit("emitEditCriador", c);
    },
    /* enviar al parent eliminar coprop */
    eliminar(idx) {
      this.$emit("emitDelCriador", idx);
    },
  },
  computed: {
    criadores() {
      return this.lista;
    },
  },
};
</script>

<style scoped></style>
